import axios from "axios";
import { DataTable } from "simple-datatables";
import { showAlert, showConfirm, handleRequestError } from "../../utils/alert";

export default () => ({
  // Modal States
  isModalOpen: false,
  isSubmitting: false,

  // Edit States
  editMode: false,
  editId: null,

  // Data Storage
  permissionsList: [],

  // Form Payload
  permissionForm: { name: "", description: "" },

  // DataTable Instance
  permissionsDataTable: null,

  async initPermissions() {
    const token = localStorage.getItem("admin_jwt_token");
    if (!token) {
      window.location.href = "/admin/login";
      return;
    }

    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    await this.loadPermissionsTable();
  },

  // ================= DATA TABLE =================

  async loadPermissionsTable() {
    try {
      const response = await axios.get("/api/admin/permissions");
      this.permissionsList = response.data.data;

      if (this.permissionsDataTable) {
        this.permissionsDataTable.destroy();
      }

      const tbody = document.querySelector("#permissionsTable tbody");
      tbody.innerHTML = this.permissionsList
        .map(
          (permission) => `
        <tr>
          <td class="py-4 px-4 xl:px-6">
            <p class="font-medium text-slate-800">${permission.description}</p>
          </td>
          <td class="py-4 px-4 xl:px-6">
            <span class="inline-flex rounded-md bg-slate-50 px-2 py-1 text-xs font-medium text-slate-600 ring-1 ring-inset ring-slate-500/10 tracking-wider">
              ${permission.name}
            </span>
          </td>
          <td class="py-4 px-4 xl:px-6 text-slate-500 text-sm">
            ${permission.created_at}
          </td>
          <td class="text-left py-4 px-4 xl:px-6">
            <div class="flex justify-start gap-2">
              <button
                onclick="window.dispatchEvent(new CustomEvent('edit-permission', {detail: ${permission.id}}))"
                class="inline-flex items-center justify-center rounded-md bg-orange-500 px-3 py-1.5 text-xs font-semibold text-white shadow-sm transition-colors hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-500"
              >
                Editar
              </button>
              <button
                onclick="window.dispatchEvent(new CustomEvent('delete-permission', {detail: ${permission.id}}))"
                class="inline-flex items-center justify-center rounded-md bg-red-600 px-3 py-1.5 text-xs font-semibold text-white shadow-sm transition-colors hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-600"
              >
                Excluir
              </button>
            </div>
          </td>
        </tr>
      `,
        )
        .join("");

      this.permissionsDataTable = new DataTable("#permissionsTable", {
        searchable: false, // Enable search for permissions
        perPageSelect: false,
        perPage: 50,
        labels: {
          info: "Mostrando de {start} até {end} de {rows} registos",
          noRows: "Nenhuma permissão cadastrada",
          noResults: "Nenhum resultado encontrado",
          searchTitle: "Pesquisar...",
        },
      });
    } catch (error) {
      console.error(error);
    }
  },

  // ================= MODAL HANDLERS =================

  openCreatePermission() {
    this.editMode = false;
    this.permissionForm = { name: "", description: "" };
    this.isModalOpen = true;
  },

  openEditPermission(id) {
    this.editMode = true;
    this.editId = id;
    const permission = this.permissionsList.find((p) => p.id === id);

    this.permissionForm = {
      name: permission.name,
      description: permission.description,
    };
    this.isModalOpen = true;
  },

  // ================= SUBMIT =================

  async submitPermission() {
    this.isSubmitting = true;
    try {
      if (this.editMode) {
        await axios.put(
          `/api/admin/permissions/${this.editId}`,
          this.permissionForm,
        );
        showAlert("Permissão atualizada com sucesso!", "success");
      } else {
        await axios.post("/api/admin/permissions", this.permissionForm);
        showAlert("Permissão criada com sucesso!", "success");
      }

      await this.loadPermissionsTable();
      this.isModalOpen = false;
    } catch (error) {
      handleRequestError(error, "Erro ao guardar a permissão.");
    } finally {
      this.isSubmitting = false;
    }
  },

  // ================= DELETE =================

  async deletePermission(id) {
    const result = await showConfirm(
      "Excluir Permissão",
      "Tem certeza que deseja excluir esta permissão? Esta ação afetará funções associadas.",
    );

    if (result.isConfirmed) {
      try {
        await axios.delete(`/api/admin/permissions/${id}`);
        await this.loadPermissionsTable();
        showAlert("Permissão removida com sucesso.", "success");
      } catch (error) {
        handleRequestError(error, "Erro ao excluir a permissão.");
      }
    }
  },
});
